import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import { baseUrl, baseUrlCSRFCookie } from "../../../resources/Constants";
import logo from '../../../resources/img/smileweb.png';
import ReCAPTCHA from "react-google-recaptcha";
import './Login2.css';

// Instancia axios para hacer solicitud del CSRF Cookie al backend
const axiosInstanceCSRFCookie = axios.create({
    baseURL: baseUrlCSRFCookie,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
});

// Instancia axios para autenticación
const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    },
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
});

function Login2(props) {
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedbackType, setFeedbackType] = useState('invalid-feedback');
    const [msg, setMsg] = useState('');
    const [captchaValue, setCaptchaValue] = useState(null);

    let history = useHistory();

    const onCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!captchaValue) {
            setFeedbackType('invalid-feedback visible');
            setMsg('Por favor, completa el captcha');
            return;
        }

        setLoading(true);

        axiosInstanceCSRFCookie.get('/sanctum/csrf-cookie')
            .then(response => {
                axiosInstance.post('/login', {
                    login: login,
                    password: password
                })
                    .then(
                        response => {
                            setMsg('');
                            setLoading(false);

                            localStorage.setItem('userdata', JSON.stringify(response.data));

                            if (response.data.user_status == '1') {
                                history.push('/home');
                            }
                            else {
                                history.push('/new-user');
                            }
                        }
                    )
                    .catch(
                        err => {
                            setFeedbackType('invalid-feedback visible');
                            setMsg(err.response.data.message);
                            setLoading(false);
                        }
                    )
            })
            .catch(error => {
                console.log('Error obteniendo la cookie CSRF');
                console.log(error);
                setFeedbackType('invalid-feedback visible');
                setMsg('Error de conexión. Intenta nuevamente.');
                setLoading(false);
            });
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-logo">
                    <img src={logo} alt="SmileWEB Logo" />
                </div>
                
                <h2 className="login-title">¡Bienvenido a SmileWEB!</h2>
                <p className="login-subtitle">Sistema Integral de Gestión Médica y Odontológica</p>

                <form onSubmit={handleSubmit} method="post" noValidate className="login-form">
                    <div className="form-group">
                        <label htmlFor="login">Usuario</label>
                        <div className="input-with-icon">
                            <i className="fas fa-user"></i>
                            <input 
                                type="text" 
                                id="login"
                                className="form-control" 
                                placeholder="Ingresa tu usuario" 
                                autoFocus={true} 
                                onChange={e => setLogin(e.target.value)}
                                value={login}
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <div className="input-with-icon">
                            <i className="fas fa-lock"></i>
                            <input 
                                type="password" 
                                id="password"
                                className="form-control" 
                                placeholder="Ingresa tu contraseña" 
                                onChange={e => setPassword(e.target.value)}
                                value={password}
                            />
                        </div>
                    </div>

                    <div className="form-group captcha-container">
                        <ReCAPTCHA
                            sitekey={process.env.REACT_APP_RECAPTCHA_SITEKEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
                            onChange={onCaptchaChange}
                        />
                    </div>

                    {msg && (
                        <div className="alert alert-danger" role="alert">
                            {msg}
                        </div>
                    )}

                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                Ingresando...
                            </>
                        ) : (
                            'Ingresar'
                        )}
                    </button>
                </form>

                <div className="login-links">
                    <Link to={'/request-password'} className="login-link">
                        <i className="fas fa-key"></i> Olvidé mi contraseña
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Login2;